import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import SeeAllLink from 'components/SeeAllLink';
import Hidden from '@material-ui/core/Hidden';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import ListTitle from 'components/ListTitle';
import Divider from 'components/Divider';
import { makeSelectHomeHeaders } from 'containers/Main/selectors';
import withAppContainer from 'components/WithAppContainer';
import useWindowSize from 'components/useWindowSize';
import { getHomeNews } from '../actions';
import { makeSelectNews } from '../selectors';
import BigNewsCard from './News/BigNewsCard';
import SmallNewsCard from './News/SmallNewsCard';

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('400')]: {
      position: 'relative',
    },
    marginTop: 54,
  },
  viewMore: {
    display: 'flex',
    justifyContent: 'center',
  },
  smallCards: {
    paddingLeft: '20px !important',
    [theme.breakpoints.down('991')]: {
      paddingLeft: '8px !important',
    },
  },
}));

function NewsList({ grayscale }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const homeHeaders = useSelector(makeSelectHomeHeaders());
  const news = useSelector(makeSelectNews());
  const { width } = useWindowSize();
  const isMobile = width <= 600;

  useEffect(() => {
    dispatch(getHomeNews());
  }, [dispatch]);

  if (_isEmpty(news) || _isEmpty(news.data)) {
    return null;
  }

  const title = _get(homeHeaders, 'pageCopy.news', '');
  const linkLabel = _get(homeHeaders, 'pageCopy.newsLinkLabel', '');
  const { data } = news;
  const [first, ...rest] = data;

  return (
    <Grid
      container
      spacing={2}
      className={classes.root}
      data-test-id="home-latest-news"
    >
      <Grid item xs={12}>
        <Grid container direction="row" justifyContent="space-between">
          <Grid item xs={12} sm={8}>
            <ListTitle title={title} />
          </Grid>
          <Hidden xsDown>
            <SeeAllLink link="news" label={linkLabel} />
          </Hidden>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={6}>
        <BigNewsCard data={first} grayscale={grayscale} />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.smallCards}>
        <Grid container>
          {rest.map(el => (
            <React.Fragment key={_get(el, 'fields.slug')}>
              {isMobile && (
                <Grid item xs={12}>
                  <Divider bottom={12} />
                </Grid>
              )}
              <SmallNewsCard
                data={el}
                key={_get(el, 'fields.slug')}
                grayscale={grayscale}
              />
            </React.Fragment>
          ))}
        </Grid>
      </Grid>
      <Hidden smUp>
        <Grid item xs={12} className={classes.viewMore}>
          <SeeAllLink link="news" isMobile bordered align="center" />
        </Grid>
      </Hidden>
    </Grid>
  );
}

NewsList.propTypes = {
  grayscale: PropTypes.bool,
};

export default withAppContainer(NewsList);
